import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import AddUserForm from "./users/templates/AddUserForm";
import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { useEffect, useState } from "react";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  initialUser?: AuthUserModel;
}

export function CreateEditUserModal({
  isVisible,
  onClose,
  onSuccess,
  initialUser,
}: Props) {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsEditing(!!initialUser);
    }
  }, [isVisible, initialUser]);

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      title={isEditing ? "Edit User" : "Create new user"}
      className="w-full max-w-[737px] lg:w-[737px] mx-auto "
      hasCancelButton
      isEditing={isEditing}
    >
      <AddUserForm
        onClose={onClose}
        onSuccess={onSuccess}
        isEditing={isEditing}
        initialUser={initialUser}
      />
    </ReusableModal>
  );
}
